document.addEventListener('DOMContentLoaded', function() {
  // Mega menu functionality
  const megaMenuItems = document.querySelectorAll('.has-megamenu');
  
  megaMenuItems.forEach(item => {
    let hoverTimeout;
    
    item.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      const megaMenu = this.querySelector('.mega-menu');
      if (megaMenu) {
        megaMenu.style.display = 'block';
        initializeMegaMenuNavigation(megaMenu);
        
        // Emit mega menu open event
        const megaMenuOpenEvent = new CustomEvent('megaMenuOpen', {
          detail: { menuItem: this }
        });
        document.dispatchEvent(megaMenuOpenEvent);
      }
    });
    
    item.addEventListener('mouseleave', function() {
      const megaMenu = this.querySelector('.mega-menu');
      hoverTimeout = setTimeout(() => {
        if (megaMenu) {
          megaMenu.style.display = 'none';
          
          // Emit mega menu close event
          const megaMenuCloseEvent = new CustomEvent('megaMenuClose', {
            detail: { menuItem: this }
          });
          document.dispatchEvent(megaMenuCloseEvent);
        }
      }, 100);
    });
  });

  // Mega menu navigation functionality
  function initializeMegaMenuNavigation(megaMenu) {
    const childItems = megaMenu.querySelectorAll('.mega-menu__child-item');
    const grandchildrenGroups = megaMenu.querySelectorAll('.mega-menu__grandchildren-group');
    
    childItems.forEach(childItem => {
      childItem.addEventListener('mouseenter', function() {
        const childIndex = this.dataset.childIndex;
        
        // Remove active class from all child items
        childItems.forEach(item => item.classList.remove('is-active'));
        // Add active class to current child item
        this.classList.add('is-active');
        
        // Hide all grandchildren groups
        grandchildrenGroups.forEach(group => group.classList.remove('is-active'));
        
        // Show corresponding grandchildren group
        const targetGroup = megaMenu.querySelector(`[data-grandchild-group="${childIndex}"]`);
        if (targetGroup) {
          targetGroup.classList.add('is-active');
        }
      });
    });
  }

  // Search functionality
  const searchButtons = document.querySelectorAll('.js-toggle-search');
  searchButtons.forEach(searchButton => {
    searchButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Cerrar el menú móvil si está abierto
      const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
      if (mobileMenuOverlay && mobileMenuOverlay.getAttribute('aria-hidden') === 'false') {
        mobileMenuOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.body.classList.remove('mobile-menu-open');
      }
      
      // Abrir drawer de búsqueda
      const drawerEvent = new CustomEvent('openDrawer', {
        detail: {
          drawerId: 'search',
          position: 'right'
        }
      });
      document.dispatchEvent(drawerEvent);
    });
  });

  // Cart functionality
  const cartButtons = document.querySelectorAll('.js-toggle-cart');
  cartButtons.forEach(cartButton => {
    cartButton.addEventListener('click', function(e) {
      e.preventDefault();
      // Abrir drawer del carrito
      const drawerEvent = new CustomEvent('openDrawer', {
        detail: {
          drawerId: 'cart',
          position: 'right'
        }
      });
      document.dispatchEvent(drawerEvent);
    });
  });

  // Burger menu functionality
  const burgerMenuButtons = document.querySelectorAll('.js-toggle-mobile-menu');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  
  burgerMenuButtons.forEach(burgerMenuButton => {
    burgerMenuButton.addEventListener('click', function(e) {
      e.preventDefault();
      toggleMobileMenu();
    });
  });

  function toggleMobileMenu() {
    if (mobileMenuOverlay) {
      const isOpen = mobileMenuOverlay.getAttribute('aria-hidden') === 'false';
      
      if (isOpen) {
        // Cerrar menú
        mobileMenuOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = ''; // Restaurar scroll
        document.body.classList.remove('mobile-menu-open');
        
        // Emit mobile menu close event
        const mobileMenuCloseEvent = new CustomEvent('mobileMenuClose');
        document.dispatchEvent(mobileMenuCloseEvent);
      } else {
        // Abrir menú
        mobileMenuOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden'; // Prevenir scroll del body
        document.body.classList.add('mobile-menu-open');
        
        // Emit mobile menu open event
        const mobileMenuOpenEvent = new CustomEvent('mobileMenuOpen');
        document.dispatchEvent(mobileMenuOpenEvent);
      }
    }
  }

  // Cerrar menú al hacer clic en enlaces (excepto los que tienen submenús)
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      if (link && !link.closest('.has-submenu')) {
        // Es un enlace normal, cerrar el menú
        setTimeout(() => {
          mobileMenuOverlay.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          document.body.classList.remove('mobile-menu-open');
          
          // Emit mobile menu close event
          const mobileMenuCloseEvent = new CustomEvent('mobileMenuClose');
          document.dispatchEvent(mobileMenuCloseEvent);
        }, 150);
      }
    });
  }
});